import { CommonModule } from '@angular/common'
import { Component, Input, TemplateRef, ViewEncapsulation } from '@angular/core'
import { PagedResult } from '@ftr/contracts/api/core/response/PagedResult'
import { ApiResult, BadgeComponent } from '@ftr/foundation'

@Component({
  selector: 'ftr-list-header',
  templateUrl: './list-header.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [BadgeComponent, CommonModule],
})
export class ListHeaderComponent<T> {
  /*
   * How to refer to more than one item in the list
   */
  @Input() plural: string
  /*
   * How to refer to a single item in the list
   */
  @Input() singular: string
  /*
   * The title of the list. Uses the plural if it isn't set.
   */
  @Input() listTitle?: string
  @Input() subTitle?: string

  /**
   * Label to use for summary if you are externally filtering the entities list.
   *
   * Eg '1 Active Courtroom'
   */
  @Input() currentFilter?: string

  /**
   * Allows for an ftr-badge to be displayed beside the header
   */
  @Input() badgeText?: string

  /*
   * A summary of what this list is of
   */
  @Input() summary: string
  /*
   * The items in the list
   */
  @Input() entities: ApiResult<PagedResult<T>>
  /**
   * A template for a filter option for the list
   */
  @Input() actionTemplate: TemplateRef<any> | null = null
}
